export default __webpack_public_path__ + "static/media/bath.ddded950.jpg";